import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CommandCenterService {
	constructor(private http: HttpClient) {}

	getWeekRevenue(week_id: string): Observable<any> {
		return this.http.get(`${environment.api}command-center/${week_id}/week_revenue`);
	}

	getLeadsProduced(week_id: string): Observable<any> {
		return this.http.get(`${environment.api}command-center/${week_id}/leads_produced`);
	}

	getBillableRate(week_id: string): Observable<any> {
		return this.http.get(`${environment.api}command-center/${week_id}/billable_rate`);
	}

	getLeadsRemaining(week_id: string): Observable<any> {
		return this.http.get(`${environment.api}command-center/${week_id}/leads_remaining`);
	}

	getPriorityProductionBoard(week_id: string): Observable<any> {
		return this.http.get(`${environment.api}command-center/${week_id}/priority_production_board`);
	}
}
